import Rect from './Rect';
import Vector2 from './Vector2';
import { pointInPolygon } from './Util';
import Scene from './Scene';

export default class Layer {
  private _id: string;

  private _boundingRect: Rect;
  private _scene: Scene;

  public get scene(): Scene {
    return this._scene;
  }

  public get id(): string {
    return this._id;
  }

  public get boundingRect(): Rect {
    return this._boundingRect;
  }

  public setBoundingRect(value: Rect) {
    this._boundingRect = value;
  }

  public checkPointIntersection(point: Vector2): boolean {
    return this.checkBoundingBoxIntersection(point);
  }

  public getCenter(): Vector2 {
    var points = this.getBoundingBox();
    var sum = new Vector2();

    for (var i = 0; i < points.length; i++) {
      sum = sum.add(points[i]);
    }

    return sum.divScalar(points.length);
  }

  public getBoundingBox(transformToScreen = false): Array<Vector2> {
    var rect = this.boundingRect;
    var ret = new Array<Vector2>(4);

    ret[0] = rect.position;
    ret[1] = rect.position.add(new Vector2(rect.size.x, 0));
    ret[2] = rect.position.add(rect.size);
    ret[3] = rect.position.add(new Vector2(0, rect.size.y));

    if (transformToScreen) {
      for (var i = 0; i < 4; i++) {
        ret[i] = this.scene.camera.transformPointWorldToScreen(ret[i]);
      }
    }

    return ret;
  }

  protected checkBoundingBoxIntersection(point: Vector2): boolean {
    var points = this.getBoundingBox();
    return pointInPolygon(points, point);
  }

  public constructor(scene: Scene, id: string, boundingRect = new Rect()) {
    this._id = id;
    this._scene = scene;
    this._boundingRect = boundingRect;
  }
}
